export default {
  singleLabel: "Contact",
  storeNamespace: 'agency_contact',
  authFeature: 'agency-contact',
  listRouteName: "AgencyContactList",
  newRouteName: "AgencyContactNew",
  editRouteName: "AgencyContactEdit",
  detailRouteName: "AgencyContactDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'AgencyContactForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'fullname',
  sortBy: 'firstname',
  showExtendedFilters: true,
  fields: [
    {
      name: 'agency',
      label: "Agence",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      extendedFilter: true,
      filterIn: true,
      inDetail: true,
      detailLink: 'AgencyDetail',
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'email',
      label: "Email",
      type: 'email',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      link: (context, value) => value ? 'mailto:' + value : null,
      isHtml: true,
      formatter: (context, value) => value ? '<a href="mailto:' + value + '">' + value + '</a>' : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/AgencyContact/config.js